<template>
  <div class="hab-list">
    <div
        v-for="(item, index) in data"
        :key="index"
        class="hab-item"
    >
      <div
        :id="`ticket-${get(item, 'route.schedules.0.trip_code', '')}`"
        class="p12"
      >
        <div
          v-if="!isEmpty(get(item, 'notification', {}))"
          :class="`hab-item__notification ${showClassNotification(get(item, 'notification', {}))}`"
        >
          <span>{{ showLabelNotification(get(item, "notification", {})) }}</span>
          <span
            :class="[
              {
              'has-content': item?.notification?.content || item?.notification?.english_content
              }
            ]"
            @mouseover="onTooltip(index, true)"
            @mouseleave="onTooltip(index, false)"
          >{{ showNotification(get(item, "notification", {})) }}</span>
          <div v-if="tooltip?.some(e => e?.id === index && e?.status)" v-html="$i18n.locale === 'vn' ? item?.notification?.content : item?.notification?.english_content" class="notification-content"></div>
        </div>
        <div
          v-if="!isEmpty(get(item, 'important_notification', {}))"
          :class="`hab-item__notification ${showClassNotification(get(item, 'important_notification', {}))}`"
        >
          <span :class="[{ 'important': item?.important_notification?.category === 4 }]">{{ showLabelNotification(get(item, "important_notification", {})) }}</span>
          <span
            :class="[
              {
              'has-content': item?.important_notification?.content || item?.important_notification?.english_content
              }
            ]"
            @mouseover="onTooltipImportant(index, true)"
            @mouseleave="onTooltipImportant(index, false)"
          >{{ showNotification(get(item, "important_notification", {})) }}</span>
          <div v-if="tooltipImportant?.some(e => e?.id === index && e?.status)" v-html="$i18n.locale === 'vn' ? item?.important_notification?.content : item?.important_notification?.english_content" class="notification-content"></div>
        </div>
        <div class="hab-item__box">
          <div
              class="hab-item__image"
              :style="`background-image: url(${get(
            item,
            'company.images.0.files.1000x600',
            ''
          )})`"
          ></div>
          <div class="hab-item__price-box">
            <div class="hab-item__price-box__value">
              {{ showPrice(get(item, "route.schedules.0.fare", {})) }}
            </div>
            <div
                v-if="showOldPrice(get(item, 'route.schedules.0.fare', {}))"
                class="hab-item__price-box__value-small"
            >
              {{ showOldPrice(get(item, "route.schedules.0.fare", {})) }}{{currency}}
            </div>
          </div>
          <div class="hab-item__content">
            <div class="hab-item__bus-info">
              <div class="hab-item__bus-info__name">
                {{ get(item, "company.name", "") }}
                <span class="hab-item__bus-info__rating-button">
                <svg
                    viewBox="64 64 896 896"
                    focusable="false"
                    class=""
                    data-icon="star"
                    width="1em"
                    height="1em"
                    fill="#fff"
                    aria-hidden="true"
                >
                  <path
                      d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"
                  ></path>
                </svg>
                <span>{{
                    get(item, "company.ratings.overall", 0)
                  }}</span> </span
                ><small>
                • {{ get(item, "company.ratings.comments", 0) }}
                {{ $t("list.reviews") }}</small
              >
              </div>
            </div>
            <div class="hab-item__seat-type">
              {{ get(item, "route.schedules.0.vehicle_type", "") }}
            </div>
          </div>
          <div class="hab-item__content hab-item__content--mb">
            <div class="hab-item__content-footer">
              <div class="hab-item__schedule">
                <div>
                  <svg
                      class="TicketPC__LocationRouteSVG-sc-1mxgwjh-4 eKNjJr"
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="74"
                      viewBox="0 0 14 74"
                  >
                    <path
                        fill="none"
                        stroke="#787878"
                        stroke-linecap="round"
                        stroke-width="2"
                        stroke-dasharray="0 7"
                        d="M7 13.5v46"
                    ></path>
                    <g fill="none" stroke="#008000" stroke-width="3">
                      <circle cx="7" cy="7" r="7" stroke="none"></circle>
                      <circle cx="7" cy="7" r="5.5"></circle>
                    </g>
                    <path
                        d="M7 58a5.953 5.953 0 0 0-6 5.891 5.657 5.657 0 0 0 .525 2.4 37.124 37.124 0 0 0 5.222 7.591.338.338 0 0 0 .506 0 37.142 37.142 0 0 0 5.222-7.582A5.655 5.655 0 0 0 13 63.9 5.953 5.953 0 0 0 7 58zm0 8.95a3.092 3.092 0 0 1-3.117-3.06 3.117 3.117 0 0 1 6.234 0A3.092 3.092 0 0 1 7 66.95z"
                        fill="#008000"
                    ></path>
                  </svg>
                  <div class="hab-item__schedule__content">
                    <div class="hab-item__schedule-from">
                    <span class="hour">{{
                        formatTime(get(item, "route.schedules.0.pickup_date", ""))
                      }}</span>
                      • {{ get(item, "route.from.name", "") }}
                    </div>
                    <div class="hab-item__schedule-duration">
                      {{
                        getScheduleDuration(get(item, "route.schedules.0", {}))
                      }}
                    </div>
                    <div class="hab-item__schedule-to">
                    <span class="hour">{{
                        formatTime(
                            get(item, "route.schedules.0.arrival_time", "")
                        )
                      }}</span>
                      • {{ get(item, "route.to.name", "") }}
                    </div>
                  </div>
                </div>
                <div
                    v-if="!isEmpty(get(item, 'social_proof_ratings', []))"
                    class="hab-item__social-ratings"
                >
                <span
                    v-for="(item, key) in get(item, 'social_proof_ratings', [])"
                    :key="key"
                >{{
                    $i18n.locale === "vn" ? item.label : item.label_english
                  }}</span
                >
                </div>
              </div>
            </div>
          </div>
          <div
              v-if="get(item, 'route.schedules.0.available_seats', 0) != 0"
              class="hab-item__booking-box"
          >
            <div class="hab-item__seat-available">
              {{
                $t("list.seats_left", {
                  count: get(item, "route.schedules.0.available_seats", 0),
                })
              }}
            </div>
            <div class="hab-item__action">
                <span
                    class="hab-item__action__view-detail"
                    @click="() => onView(index, get(item, 'route.schedules.0.trip_code', ''))"
                ><img src="/public/images/icon-view.png" />{{
                    $t("list.detail")
                  }}</span>
              <span
                  class="hab-item__action__booking"
                  @click="onBook(index, get(item, 'route.schedules.0.trip_code', ''))"
              >{{ $t("list.book") }}</span>
              <span
                  class="hab-item__action__booking hab-item__action__booking-mb"
                  @click="onBook(index, get(item, 'route.schedules.0.trip_code', ''))"
              >{{ $t("list.book1") }}</span>
            </div>
          </div>
        </div>
        <div v-if="viewInfo === index || open_bottom === index">
          <detail :key="index" v-if="detail_mode === 1" :dataSource="item" />
          <book
              v-if="detail_mode === 2"
              :trip-code="get(item, 'route.schedules.0.trip_code', '')"
              :company-name="get(item, 'company.name', '')"
              :company-id="get(item, 'company.id', 0)"
              :vehicle-type="get(item, 'route.schedules.0.vehicle_type', '')"
              :route-name="get(item, 'route.name', '')"
              :resource="item"
              :unchoosable="get(item, 'route.schedules.0.unchoosable', 0)"
              @close="closeModalFooter"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, isEmpty } from "lodash";
import { formatMoney } from "../../../utils/helpers";
import detail from "./detail";
import book from "./book";

export default {
  components: {
    detail,
    book,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      detail_mode: 1,
      open_bottom: null,
      viewInfo: null,
      tooltip: [],
      tooltipImportant: []
    };
  },
  computed: {
    currency () {
      return this.$i18n.locale === "vn" ? "đ" : "VND";
    }
  },
  methods: {
    get,
    isEmpty,
    formatTime(val) {
      if (!val) {
        return "";
      }
      return moment(val).format("HH:mm");
    },
    getScheduleDuration(schedule) {
      let start = get(schedule, "pickup_date", "");
      let end = get(schedule, "arrival_time", "");
      if (!start || !end) {
        return "";
      }

      const startTime = moment(start);
      const endTime = moment(end);
      const duration = moment.duration(endTime.diff(startTime));

      const hours = parseInt(duration.asHours());
      let minutes = parseInt(duration.asMinutes()) % 60;

      if (minutes === 0) {
        minutes = '00'
      }

      return hours + "h" + minutes + "m";
    },
    showPrice(fare) {
      if (isEmpty(fare)) {
        return "";
      }
      let char = "";
      if (fare.original !== fare.max) {
        char = this.$t("list.from") + " ";
      }

      const currency = this.$i18n.locale === "vn" ? "đ" : "VND";
      if (fare.discount !== -1) {
        return char + formatMoney(fare.discount) + currency;
      }

      return char + formatMoney(fare.original) + currency;
    },
    showOldPrice(fare) {
      if (isEmpty(fare) || fare.discount === -1) {
        return "";
      }

      return formatMoney(fare.original);
    },
    showNotification(notification) {
      return this.$i18n.locale === 'vn' ? get(notification, "label", "") : get(notification, "english_label", "");
    },
    showClassNotification(notification) {
      if (get(notification, "category", 1) === 2) {
        return "hab-item__notification--discount";
      }
      if (get(notification, "category", 1) === 3) {
        return "hab-item__notification--promotion";
      }
      if (get(notification, "category", 1) === 4) {
        return "hab-item__notification--important";
      }

      return "";
    },
    showLabelNotification(notification) {
      if (get(notification, "category", 1) === 2) {
        return this.$t("list.discount");
      }
      if (get(notification, "category", 1) === 3) {
        return this.$t("list.promotion");
      }
      if (get(notification, "category", 1) === 4) {
        return this.$t("list.important");
      }

      return this.$t("list.notice");
    },
    onView(index, tripCode) {
      this.viewInfo = this.viewInfo === index ? null : index;
      this.open_bottom = null
      this.detail_mode = 1;
      this.$nextTick(() => {
        this.scrollTo("ticket-" + tripCode)
      })
    },
    onBook(index, tripCode) {
      this.open_bottom = this.open_bottom === index ? null : index;
      this.viewInfo = null
      this.detail_mode = 2;
      this.$nextTick(() => {
        this.scrollTo("ticket-" + tripCode)
      })
    },
    scrollTo(idElement) {
      const element = document.getElementById(idElement);
      element.scrollIntoView();
    },
    closeModalFooter() {
      this.open_bottom = null
      this.viewInfo = null
    },
    onTooltip(index, status) {
      const a = this.tooltip?.findIndex(e => e?.id === index);
      if (a === -1) {
        this.tooltip = [...this.tooltip, { id: index, status: status }]
      } else {
        this.tooltip = this.tooltip?.map(e => e?.id === index ? ({ ...e, status: status }) : e)
      }
    },
    onTooltipImportant(index, status) {
      const a = this.tooltipImportant?.findIndex(e => e?.id === index);
      if (a === -1) {
        this.tooltipImportant = [...this.tooltipImportant, { id: index, status: status }]
      } else {
        this.tooltipImportant = this.tooltipImportant?.map(e => e?.id === index ? ({ ...e, status: status }) : e)
      }
    }
  }
};
</script>
